import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./BurgerMenu.module.scss";

interface BurgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ isOpen, onClose }) => {
  const [isScreenWide, setIsScreenWide] = useState<boolean>(
    window.innerWidth > 1050
  );

  useEffect(() => {
    const handleResize = () => {
      setIsScreenWide(window.innerWidth > 1050);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Якщо ширина екрана більше за 1000px, закриваємо меню
  useEffect(() => {
    if (isScreenWide) {
      onClose();
    }
  }, [isScreenWide, onClose]);

  if (!isOpen) return null; // або control visibility via styles

  return (
    <div className={styles.burgerMenu}>
      <div className={styles.menu}>
        <button className={styles.close} onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
          >
            <path
              fill="#202428"
              fillRule="evenodd"
              d="M.293.293a1 1 0 0 1 1.414 0l30 30a1 1 0 0 1-1.414 1.414l-30-30a1 1 0 0 1 0-1.414Zm31.414 0a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Zm-18 18a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
        <div className="container">
          <nav className={styles.nav}>
            <Link to="/leistungen-werkstatt-berlin/" onClick={onClose}>
              Werkstattservice Berlin
            </Link>

            <Link to="/leistungen-de_at/" onClick={onClose}>
              Postversand DE&EU
            </Link>

            <Link to="/shop/" onClick={onClose}>
              Shop
            </Link>

            <Link to="/uber-uns/" onClick={onClose}>
              Über Uns
            </Link>

            <Link to="/unsere-partner/" onClick={onClose}>
              Partner
            </Link>

            <Link to="/karriere/" onClick={onClose}>
              Karriere
            </Link>

            <Link to="/faq/" onClick={onClose}>
              F.A.Q
            </Link>

            <Link to="/kontakt/" onClick={onClose}>
              Kontakt
            </Link>

            <Link to="/reviews/" onClick={onClose}>
              Reviews
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default BurgerMenu;
